const getRedirectPath = (from, { metaMoviePk } = {}) => {
    if (from === 'tmdblist') return '/tmdb'
    if (from === 'previewmovies') {
        return metaMoviePk ? `/website/previewMovies/movie/${metaMoviePk}` : '/website/previewMovies'
    }
    if (from === 'editallmovies') return '/movies'
    if (from && from.startsWith('editmovie/')) return `/movies/movie/${from.split('/')[1]}/edit-item`
    if (from && from.startsWith('/')) return from
    try {
        const decoded = decodeURIComponent(from || '')
        if (decoded.startsWith('/')) return decoded
    } catch (e) {}
    return '/tmdb'
}

export default getRedirectPath
